var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isFirst,
          expression: "isFirst"
        }
      ],
      staticClass: "first-notice-wrapper"
    },
    [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("beforeUse.title")))
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "first-notice" }, [
          _c("li", [_vm._v(_vm._s(_vm.$t("beforeUse.text1")))]),
          _vm._v(" "),
          _c("li", [_vm._v(_vm._s(_vm.$t("beforeUse.text2")))]),
          _vm._v(" "),
          _c("li", [_vm._v(_vm._s(_vm.$t("beforeUse.text3")))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "__btn __btn_all_in", on: { click: _vm.close } },
          [_vm._v(_vm._s(_vm.$t("btn.understand")))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }